var IDENTIFIERS = [
    'TITLE',
    'DESCRIPTION',
    'OG_TITLE',
    'OG_DESCRIPTION',
    'OG_IMAGE',
    'FB_ADMINS',
    'ROBOTS',
    'CANONICAL',
    'STRUCTURED_DATA',
    'OG_IMAGE_WIDTH',
    'OG_IMAGE_HEIGHT',
].reduce(function (acc, curr) {
    acc[curr] = curr;
    return acc;
}, {});
var GENERAL_IDENTIFIERS = {
    LINK: 'LINK',
    OG_TAG: 'OG_TAG',
    SATANDARD_META: 'SATANDARD_META',
};
export { IDENTIFIERS, GENERAL_IDENTIFIERS };
